import React from 'react';
import { SVGIconProps } from './props';

const FreedialSVGIcon = (props: SVGIconProps) => {
    return (
        <span className={props.className}>
            <svg width='25' height='17' viewBox='0 0 25 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <g>
                    <path d='M25 0H0V17H25V0Z' fill={props.bg_fill ?? '#484848'} />
                    <path
                        d='M6.28313 13.1859C4.91057 13.1859 3.20885 12.0944 3.20885 9.84022C3.20885 8.09298 4.86503 6.69519 6.28313 5.8604C7.69295 6.69519 9.35534 8.09298 9.35534 9.84022C9.35534 12.0944 7.65361 13.1859 6.28313 13.1859ZM15.7006 9.80355C15.7006 8.05416 17.3567 6.65636 18.7748 5.82157C20.1867 6.65636 21.8471 8.05416 21.8471 9.80355C21.8471 12.0556 20.1453 13.1492 18.7748 13.1492C17.4044 13.1492 15.7006 12.0556 15.7006 9.80355ZM24.9959 2.64634C22.4557 2.64634 20.2054 3.30641 18.6755 4.13473C16.7597 3.13242 14.6416 2.6221 12.4979 2.64634C10.353 2.62199 8.2335 3.13231 6.31625 4.13473C4.78843 3.30641 2.54017 2.64634 0.0020752 2.64634V4.13473C1.50299 4.13473 3.32478 4.42594 4.76359 5.07522C3.2192 6.15376 1.68931 7.78236 1.68931 9.84022C1.68931 12.5603 3.91272 14.6397 6.32453 14.6397C7.53456 14.6249 8.68982 14.1119 9.5381 13.2127C10.3864 12.3135 10.8588 11.1011 10.8521 9.84022C10.8521 7.78236 9.43194 6.15161 7.88755 5.07522C10.8483 3.82114 14.162 3.82114 17.1228 5.07522C15.5784 6.15376 14.1583 7.78236 14.1583 9.84022C14.1516 11.1007 14.6237 12.3128 15.4715 13.212C16.3194 14.1111 17.4741 14.6244 18.6838 14.6397C19.9015 14.6279 21.0661 14.1183 21.9268 13.2207C22.7876 12.323 23.2756 11.1091 23.2859 9.84022C23.2859 7.78236 21.7912 6.15161 20.2468 5.07522C21.6773 4.42809 23.5032 4.13473 25.0083 4.13473L24.9959 2.64634Z'
                        fill={props.front_fill ?? '#fff'}
                    />
                </g>
                <defs>
                    <clipPath id='clip0_534_117'>
                        <rect width='25' height='17' fill='white' />
                    </clipPath>
                </defs>
            </svg>
        </span>
    );
};

export default FreedialSVGIcon;
